import {svgIconWrapper} from '../svg-icon-wrapper';

import ActivityLogRegularAi from './activity-log-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ActivityLogRegularAi {...validProps} />;
}
SvgComponent.iconName = 'activityLogRegularAi';

export const ActivityLogRegularAiIcon = svgIconWrapper(SvgComponent);
